import { inject, Injectable } from '@angular/core';
import { SessionService } from '../../services';
import { DynamicFilters, ReportRequestBodyStrategy, TracingInfo } from '../../interfaces';
import moment from 'moment/moment';
import { dateTransform } from '../../functions/date-transform';

@Injectable({ providedIn: 'root' })
export class VerificationRequestBodyStrategy
  implements ReportRequestBodyStrategy
{
  sessionService = inject(SessionService);
  csvLimit = 10000000;
  pageLimit = 100;

  buildRequestBody(config: any, tracingInfo: TracingInfo): ReportRequestBodyStrategy {
    const {
      offset = 0,
      limit,
      allFilters,
      formData,
      columns,
      executionType,
      isGrandTotal = false,
      sorting,
      template,
      exportReportName,
      isSending
    } = config;
    
    let templateName: string | undefined = '';

    const name = template?.template_name;

    if (executionType === 'csv_load') {
      if (!name) {
        templateName = exportReportName;
      } else if (name.includes(exportReportName) || isSending) {
        templateName = name;
      } else {
        templateName = `${exportReportName}_${name}`;
      }
    } else {
      templateName = name;
    }

    const result: any = {
      p_columns: columns,
      p_additional_params: {},
      p_tracing_info: Object.assign( {
        p_template_name: templateName || null,
        p_template_id: template ? template.template_id : null,
      }, tracingInfo),
      p_advanced_filtering: {
        p_offset: offset || 0,
        p_limit:
          executionType === 'csv_load'
            ? this.csvLimit
            : limit === null
            ? this.pageLimit
            : limit,
        p_order_by: sorting?.field || null,
        p_order_by_asc_desc: sorting?.value || null,
      },
      p_is_grandtotal: isGrandTotal,
      p_execution_type: executionType,
      p_columns_mask: null,
      p_show_last_verification: formData.show_last_verification,
    };

    allFilters.forEach((field: DynamicFilters) => {
      const { field_id, is_default } = field;
      if (field_id === 'documents') {
        return;
      }

      let value;
      if (field_id === 'merchant') {
        value = this.nullUndefinedOrEmpty(formData['merchant_name']) ? null : formData['merchant_name']
      } else {
        value = this.nullUndefinedOrEmpty(formData[field_id]) ? null : formData[field_id];
      }
      const prefixedKey =
        field_id === 'merchant_name' ? 'p_domains' : `p_${field_id}`;

      if (field.field_data_type === 'TIMESTAMP' && value) {
        const { start, end, alias } = value;
        if (start && end || alias && alias !== 'custom') {
          let startDate = structuredClone(start);
          let endDate = structuredClone(end);
          if (alias && alias !== 'custom') {
            startDate = dateTransform(alias, 'start');
            endDate = dateTransform(alias, 'end');
          }
          value = [
            moment(startDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
            moment(endDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
          ];
        }
      }
      if (is_default === 'true') {
        result[prefixedKey] = value;
      } else {
        result.p_additional_params[prefixedKey] = value;
      }
    });

    return result;
  }

  private nullUndefinedOrEmpty(value: any): any {
    return value === null || value === undefined || value === '';
  }
}
